import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-risk-tolerance',
    templateUrl: './risk-tolerance.component.html',
    styleUrls: ['./risk-tolerance.component.scss'],
    standalone: false
})
export class RiskToleranceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
